import { Auth } from 'aws-amplify'
import { CognitoUser } from 'amazon-cognito-identity-js'

const getCredentials = async (): Promise<string | undefined> => {
  // The `currentAuthenticatedUser` method also refreshes the id_token if needed.
  const user: CognitoUser = await Auth.currentAuthenticatedUser()
  const userSession = user.getSignInUserSession()

  if (userSession === null) {
    return Promise.resolve(undefined)
  }

  const idToken = userSession.getIdToken()

  return Promise.resolve(idToken.getJwtToken())
}

export default getCredentials
